import { render, staticRenderFns } from "./deanCheckbox.vue?vue&type=template&id=4b8005cf&scoped=true"
import script from "./deanCheckbox.vue?vue&type=script&lang=ts"
export * from "./deanCheckbox.vue?vue&type=script&lang=ts"
import style0 from "./deanCheckbox.vue?vue&type=style&index=0&id=4b8005cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8005cf",
  null
  
)

export default component.exports